/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Editor_Prep_Ahead_PlaceholderInputs */

const en_editor_prep_ahead_placeholder = /** @type {(inputs: Editor_Prep_Ahead_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`e.g. Soak the chickpeas overnight`)
};

const de_editor_prep_ahead_placeholder = /** @type {(inputs: Editor_Prep_Ahead_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`z. B. Kichererbsen über Nacht einweichen`)
};

/**
* | output |
* | --- |
* | "e.g. Soak the chickpeas overnight" |
*
* @param {Editor_Prep_Ahead_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const editor_prep_ahead_placeholder = /** @type {((inputs?: Editor_Prep_Ahead_PlaceholderInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editor_Prep_Ahead_PlaceholderInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_editor_prep_ahead_placeholder(inputs)
	return en_editor_prep_ahead_placeholder(inputs)
});